import gsap from 'gsap'

import { MediaQuery } from '@/constants'

export const fadeAnimation = (
  node: HTMLElement,
  active: boolean,
  done: () => void
) => {
  gsap.killTweensOf(node.children)

  if (active) {
    gsap.set(node, { opacity: 1 })
    gsap.set(node.children, { opacity: 0 })
  }

  const matchMedia = gsap.matchMedia(node)

  matchMedia.add(
    {
      isSmall: MediaQuery.SMALL,
      isLarge: MediaQuery.LARGE
    },
    ({ conditions }) => {
      const { isSmall } = conditions as gsap.Conditions

      gsap
        .timeline({
          defaults: {
            duration: isSmall && !active ? 0 : 0.8,
            ease: active ? 'power2.inOut' : 'power2.out'
          },
          onComplete: done
        })
        .to(node.children, { opacity: active ? 1 : 0 })
    }
  )
}
